import { Inject, Injectable } from '@angular/core';
import { ProductListV2ConfigService } from '../product-list-v2-config/product-list-v2-config.service';
import { first, map, Observable, switchMap, tap } from 'rxjs';
import { Product } from '../../models';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';
import { ProductService } from '../products/product.service';
import { AuthService } from '../auth/auth.service';
import { ProductSortService } from '../product-sort/product-sort.service';
import { GungFlowService } from '../gung-flow/gung-flow.service';
import { MetadataService } from '../metadata/metadata.service';
import { Assortment, AssortmentService } from '../assortment.service';
import { CloudPimFiltersService } from '../cloud-pim-filters/cloud-pim-filters.service';
import { CurrentAssortmentService } from '../base-view-config/base-view-config.service';
import { GungImageUrlService } from 'gung-common';
import { NavigationConfig } from '../../models/navigation-config';
import { TranslateService } from '@ngx-translate/core';
import { CustomerStatisticsService } from '../customer-statistics/customer-statistics.service';

@Injectable({
  providedIn: 'root'
})
export class PreviouslyPurchasedProductListConfigService extends ProductListV2ConfigService {
  constructor(
    protected productService: ProductService,
    protected authService: AuthService,
    protected productSortService: ProductSortService,
    protected gungFlowService: GungFlowService,
    protected metadataService: MetadataService,
    protected assortmentService: AssortmentService,
    protected cloudPimFiltersService: CloudPimFiltersService,
    protected currentAssortmentService: CurrentAssortmentService,
    protected gungImageUrlService: GungImageUrlService,
    @Inject('environment')
    protected environment: NavigationConfig,
    protected translateService: TranslateService,
    protected selectedCustomerService: SelectedCustomerService,
    protected customerStatisticsService: CustomerStatisticsService
  ) {
    super(
      productService,
      authService,
      productSortService,
      gungFlowService,
      metadataService,
      assortmentService,
      cloudPimFiltersService,
      currentAssortmentService,
      gungImageUrlService,
      environment,
      translateService
    );
  }

  protected fetchProducts(assortment: Assortment): Observable<Product[]> {
    return this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      switchMap(selectedCustomer => this.customerStatisticsService.getStatisticsByCustomer(selectedCustomer.id).pipe(first())),
      switchMap(data => this.productService.getProductsByIds(data.map(p => p.productId)).pipe(
        map(products => {
          return this.productSortService.sortProducts(products);
        })
      ))
    );
  }
}
